
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Styled from './styled.md'
import TaggedTemplateLiteral from './tagged-template-literal.md'
import StyledComponent from './styled-component.md'
import ThemeProvider from './theme-provider.md'
import CssProp from './css-prop.md'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Primary`}</h2>
    <Styled mdxType="Styled" />
    <TaggedTemplateLiteral mdxType="TaggedTemplateLiteral" />
    <StyledComponent mdxType="StyledComponent" />
    <ThemeProvider mdxType="ThemeProvider" />
    <CssProp mdxType="CssProp" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;